// Google Analytics utility fonksiyonları

/**
 * Kullanıcı bilgilerini alır
 * @param {object} stores - Stores objesi (opsiyonel)
 * @returns {object} Kullanıcı bilgileri
 */
const getUserInfo = (stores = null) => {
    let meStore = null;

    if (stores?.meStore) {
        meStore = stores.meStore;
    } else if (typeof window !== "undefined" && window.stores?.meStore) {
        meStore = window.stores.meStore;
    }

    if (meStore) {
        const userInfo = {
            username: meStore.username || "anonymous",
            role: meStore.role || "unknown",
            userId: meStore.userId || "unknown"
        };

        if (meStore.role === "cUser" && meStore.selectedSubCompanyId) {
            userInfo.selectedSubCompanyId = meStore.selectedSubCompanyId;
        }

        return userInfo;
    }

    return {
        username: "anonymous",
        role: "unknown",
        userId: "unknown"
    };
};

/**
 * Buton tıklama olayını takip eder
 * @param {string} buttonName - Buton adı
 * @param {string} page - Bulunduğu sayfa
 * @param {object} stores - Stores objesi (opsiyonel)
 */
export const trackButtonClick = (buttonName, page, stores = null) => {
    if (typeof window !== "undefined" && window.gtag) {
        const userInfo = getUserInfo(stores);

        // Sadece cUser rolüne sahip kullanıcılar için Google Analytics olaylarını gönder
        if (userInfo.role === "cUser") {
            const eventData = {
                event_category: "ui_interaction",
                event_label: `${page}_${buttonName}`,
                custom_parameter_username: userInfo.username,
                custom_parameter_role: userInfo.role,
                custom_parameter_user_id: userInfo.userId
            };

            // cUser için selectedSubCompanyId bilgisini ekle
            if (userInfo.selectedSubCompanyId) {
                eventData.custom_parameter_subcompany_id = userInfo.selectedSubCompanyId;
            }

            window.gtag("event", "click", eventData);
        }
    }
};

/**
 * Sipariş oluşturma olayını takip eder
 * @param {string} deliveryType - Teslimat türü (opsiyonel)
 * @param {string} page - Bulunduğu sayfa
 * @param {object} stores - Stores objesi (opsiyonel)
 */
export const trackCreateDelivery = (deliveryType = "", page = "", stores = null) => {
    if (typeof window !== "undefined" && window.gtag) {
        const userInfo = getUserInfo(stores);

        // Sadece cUser rolüne sahip kullanıcılar için Google Analytics olaylarını gönder
        if (userInfo.role === "cUser") {
            const eventData = {
                event_category: "order_management",
                event_label: page ? `${page}_${deliveryType}` : deliveryType,
                custom_parameter_username: userInfo.username,
                custom_parameter_role: userInfo.role,
                custom_parameter_user_id: userInfo.userId
            };

            if (userInfo.selectedSubCompanyId) {
                eventData.custom_parameter_subcompany_id = userInfo.selectedSubCompanyId;
            }

            window.gtag("event", "create_delivery", eventData);
        }
    }
};
